var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-result-domain"},[_vm._v("\n    "+_vm._s(_vm.name)+" "),_c('span',{staticClass:"search-result-domain__tld",domProps:{"textContent":_vm._s(_vm.tld)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }